// @ts-expect-error missing types
import initReactivesearch from "@appbaseio/reactivesearch/lib/server";

import { getConfig } from "./config";
import { getPropsFilterGroup } from "./props";
import { ReactifySearchProviderProps } from "../components";


export const generateProviderProps = async (options: ReactifySearchProviderProps): Promise<ReactifySearchProviderProps> => {
  const config = await getConfig(options.shopifyPermanentDomain);
  const props = getPropsFilterGroup({
    mode: options.mode,
    config: config,
    filterGroup: config.filters[0],
  });

  return {
    ...options,
    preload: {
      config: config,
      state: await initReactivesearch(props, null, {
        app: config.index,
        url: config.endpoint,
      }),
    }
  }
}